import './style.scss'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiBell } from 'react-icons/fi'
import utility from 'src/utils/utility'
import {
    Card, Text, Flex, Box, tokens,
} from 'src/componentv2'
import { PAGE_PADDING_X, fontMedium } from 'src/model/v2/interface/constants'

interface MockChannel {
    key: string
    label: string
    description: string
    enabled: boolean
}

const INITIAL_CHANNELS: MockChannel[] = [
    { key: 'push', label: 'Push Notifications', description: 'Alerts sent directly to customer devices via the mobile app', enabled: true },
    { key: 'sms', label: 'SMS Alerts', description: 'Text message alerts for transactions and account activity', enabled: true },
    { key: 'email', label: 'Email Notifications', description: 'Email summaries and important account notices', enabled: false },
]

interface MockFeedItem {
    id: number
    title: string
    audience: string
    status: 'Published' | 'Draft'
    date: string
}

const MOCK_FEED: MockFeedItem[] = [
    { id: 1, title: 'Scheduled maintenance this weekend', audience: 'All customers', status: 'Published', date: 'Jul 22, 2026' },
    { id: 2, title: 'New savings product launching soon', audience: 'Savings account holders', status: 'Draft', date: 'Jul 18, 2026' },
]

const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
    Published: { bg: '#ECFDF3', color: '#027A48' },
    Draft: { bg: '#F2F4F7', color: '#667085' },
}

const FeedNotificationPage = () => {
    const navigate = useNavigate()
    const [channels, setChannels] = useState<MockChannel[]>(INITIAL_CHANNELS)
    const [feed] = useState<MockFeedItem[]>(MOCK_FEED)

    const toggleChannel = (key: string) => (value: boolean) => {
        setChannels((prev) => prev.map((c) => (c.key === key ? { ...c, enabled: value } : c)))
    }

    return (
        <div className="feed-notification-page" style={{ padding: `2.4rem ${PAGE_PADDING_X}` }}>

            <Card topMargin="2" padding="3.2" radius="1.2">
                <Flex items="center" gap="1.2">
                    <Box
                        width="4" height="4" radius="0.8"
                        bgColor="#F4F3FF"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <FiBell size={18} color="#6938EF" />
                    </Box>
                    <Text fontSize="1.6" style={fontMedium} color={tokens.textDark}>
                        Notification Channels
                    </Text>
                </Flex>

                <Box topMargin="2">
                    {channels.map((c) => (
                        <Flex
                            key={c.key}
                            justify="space-between"
                            items="center"
                            className="feed-notification-channel-row"
                        >
                            <Box>
                                <Text fontSize="1.4" style={fontMedium} color={tokens.textDark}>
                                    {c.label}
                                </Text>
                                <Text fontSize="1.3" color={tokens.textMuted} topMargin="0.2">
                                    {c.description}
                                </Text>
                            </Box>
                        </Flex>
                    ))}
                </Box>
            </Card>

            <Text topMargin="3.2" fontSize="1.8" style={fontMedium} className="feed-notification-subsection">
                In-App Feed
            </Text>

            <Box topMargin="1.6">
                {feed.map((item) => {
                    const s = STATUS_STYLES[item.status]
                    return (
                        <Card key={item.id} padding="2.4" radius="1.2" topMargin="1.2">
                            <Flex justify="space-between" items="center">
                                <Box>
                                    <Text fontSize="1.5" style={fontMedium} color={tokens.textDark}>
                                        {item.title}
                                    </Text>
                                    <Text fontSize="1.3" color={tokens.textMuted} topMargin="0.2">
                                        {item.audience} · {item.date}
                                    </Text>
                                </Box>

                                <span
                                    style={{
                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                        borderRadius: 999, padding: '0.2rem 1rem',
                                        fontSize: '1.2rem', fontWeight: 600,
                                        background: s.bg, color: s.color,
                                    }}
                                >
                                    {item.status}
                                </span>
                            </Flex>
                        </Card>
                    )
                })}
            </Box>
        </div>
    )
}

export default utility.routeData('feed-notification', 'Feed & Notification', <FeedNotificationPage />)